import React from 'react';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

import { CLIENT_URL_IMAGE } from '../../config.local';

const CollaboratedCompanies = ({ companies }) => {
  return companies && companies.length ? (
    <div className="liveclasses-companies-container">
      <span className="liveclasses-companies-heading">
        Collaborated Companies
      </span>
      <div className="liveclasses-companies-images-container">
        {companies.map(company => (
          <ImageBlurFallback
            className="liveclasses-companies-imagebox"
            src={`${CLIENT_URL_IMAGE}${company.logoUrl}`}
            alt={company.name}
            key={company.id}
          />
        ))}
      </div>
    </div>
  ) : null;
};
export default CollaboratedCompanies;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/CollaboratedCompanies.js